import libraryStyles from "../../library.css.ts";

export const TagRow = ({ item, tagFilter, toggleTag }) => {
  return (
    item.tags.length > 0 && (
      <div className={libraryStyles.tagRow}>
        {item.tags.map((tag) =>
          tagFilter ? (
            <button
              key={tag}
              className={libraryStyles.smallTagButton({
                active: tagFilter.has(tag),
              })}
              onClick={() => toggleTag(tag)}
            >
              #{tag}
            </button>
          ) : (
            <p key={tag}>#{tag}</p>
          ),
        )}
      </div>
    )
  );
};
